function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FileType } from './types';
import { WKWechatImageUploader } from './wechat';
import { getFileType } from './helpers';
import { getPlatForm } from '@weike/toolkit';
export var WK_UPLOADER = /*#__PURE__*/function () {
  function WK_UPLOADER(isProduction) {
    this.isProduction = isProduction;

    _defineProperty(this, "cosUploader", void 0);

    _defineProperty(this, "vodUploader", void 0);

    _defineProperty(this, "wechatUploader", new WKWechatImageUploader());

    _defineProperty(this, "platform", getPlatForm());
  }
  /**
   * 文件上传
   *
   * @param {UploadOptions} options
   * @return {*} 
   * @memberof WK_UPLOADER
   */


  var _proto = WK_UPLOADER.prototype;

  _proto.upload =
  /*#__PURE__*/
  function () {
    var _upload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
      var uploader;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getFileUploader(options);

            case 2:
              uploader = _context.sent;
              return _context.abrupt("return", uploader.upload(options));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function upload(_x) {
      return _upload.apply(this, arguments);
    }

    return upload;
  }()
  /**
   * 根据不同的文件类型动态加载调用不同的 sdk
   *
   * @private
   * @param {UploadOptions} options
   * @return {*}  {Promise<WK_FILE_UPLOADER>}
   * @memberof WK_UPLOADER
   */
  ;

  _proto.getFileUploader = function getFileUploader(options) {
    var file = options.file,
        type = options.type; // 如果是微信图片上传，直接返回实例化的微信上传对象

    if (this.platform === 'wechat' && type === 'image') {
      return Promise.resolve(this.wechatUploader);
    }

    if (!file) {
      throw new Error('file required');
    }

    var fileType = getFileType(file);

    if (!options.options || !options.options.class) {
      throw new Error('cos 和 vod 上传必须指定 class');
    }

    if (fileType === FileType.VIDEO && this.vodUploader) {
      return Promise.resolve(this.vodUploader);
    }

    if (fileType !== FileType.UNKNOWN && this.cosUploader) {
      return Promise.resolve(this.cosUploader);
    }

    return this.createUploader(fileType);
  };

  _proto.createUploader = function createUploader(fileType) {
    var _this = this;

    if (fileType === FileType.VIDEO) {
      return import('./vod').then(function (code) {
        _this.vodUploader = new code.default(_this.isProduction);
        return _this.vodUploader;
      });
    }

    if (fileType !== FileType.UNKNOWN) {
      return import('./cos').then(function (code) {
        _this.cosUploader = new code.default(_this.isProduction);
        return _this.cosUploader;
      });
    }

    throw new Error('unsupported file type');
  } // 微信localId转成serverId的方法
  ;

  _proto.localIdToServerId = function localIdToServerId(_ref) {
    var localId = _ref.localId,
        _ref$uploadType = _ref.uploadType,
        uploadType = _ref$uploadType === void 0 ? 'uploadImage' : _ref$uploadType,
        onProgress = _ref.onProgress;
    onProgress && onProgress({});
    return new Promise(function (resolve, reject) {
      wx[uploadType]({
        localId: localId,
        // 需要上传的音频（由stopRecord接口获得）或图片的本地ID
        isShowProgressTips: !onProgress,
        // 默认为true，显示进度提示
        success: function success(res) {
          var serverId = res.serverId; // 返回音频的服务器端ID

          resolve({
            serverId: serverId,
            localId: localId
          });
        },
        fail: reject
      });
    }).catch(function (err) {
      console.log('localIdToServerId fail: ', err);
    });
  };

  return WK_UPLOADER;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/index.js
// module id = 628
// module chunks = 6